module.exports = __webpack_public_path__ + "img/works_feilang_go_1.1ac57239.png";